import "../global/tab/tab";

class FeaturedCategories extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll("[role=tab]");
    this.heading = this.querySelector('.featured-categories__heading');
    this.link = this.querySelector('.featured-categories__link');
  }

  connectedCallback() {
    this.tabs.forEach(tab => {
      tab.addEventListener('click', e => {
        if (this.heading) this.heading.textContent = tab.dataset.heading;
        if (this.link) {
          this.link.textContent = tab.dataset.ctaText;
          this.link.href = tab.dataset.ctaUrl;
        }
      });
    });
  }
}

if (!customElements.get("featured-categories")) {
  customElements.define("featured-categories", FeaturedCategories);
}